import * as TYPES from './actionTypes';
import client from 'helpers/client';
import paths from 'redux/paths';
import cognito from 'helpers/cognito';
import enums from 'helpers/const';
import store from 'redux/store';

export const requestWithdrawKWallet = (params) => async (dispatch) => {
  try {
    dispatch({ type: TYPES.SUBMIT_REQUEST_WITHDRAW });
    const res = await client.sendRequest({
      path: paths.SUBMIT_REQUEST_WITHDRAW,
      params: params,
      method: 'POST',
      headers: await cognito.getHeaderAuthorization(),
    });
    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }
    dispatch({ type: TYPES.SUBMIT_REQUEST_WITHDRAW_SUCCESS, data });
    dispatch({ type: TYPES.FETCH_USER_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: TYPES.SUBMIT_REQUEST_WITHDRAW_FAILED,
      reason: err.message || 'Request Error',
    });
    return err;
  }
};

export const depositKWallet = (params) => async (dispatch) => {
  try {
    dispatch({ type: TYPES.SUBMIT_DEPOSIT });
    const res = await client.sendRequest({
      path: paths.SUBMIT_DEPOSIT,
      params: params,
      method: 'POST',
      headers: await cognito.getHeaderAuthorization(),
    });
    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }
    dispatch({ type: TYPES.SUBMIT_DEPOSIT_SUCCESS, data });
    const { amount, type } = params;
    const user = store.getState().user;
    if (type === enums.DEPOSIT_TYPE.KAT) {
      user.katAmount += amount;
    }
    if (type === enums.DEPOSIT_TYPE.KYTE) {
      user.kyteAmount += amount;
    }
    dispatch({ type: TYPES.FETCH_USER_SUCCESS, payload: { ...user } });
    return res;
  } catch (err) {
    dispatch({
      type: TYPES.SUBMIT_DEPOSIT_FAILED,
      reason: err.message || 'Deposit Error',
    });
    return err;
  }
};

export const getKWalletHistory = (params) => async (dispatch) => {
  const { type, page } = params;
  const kWallet = store.getState().kWallet;
  const { katWallet, kyteWallet } = kWallet;
  const { history, pagination } = type === enums.HISTORY_TYPE.KAT ? katWallet : kyteWallet;
  if (pagination.page === page) return;

  dispatch({ type: TYPES.GET_KWALLET_HISTORY });
  try {
    const res = await client.sendRequest({
      path: paths.GET_KWALLET_HISTORY,
      params: params,
      method: 'GET',
      headers: await cognito.getHeaderAuthorization(),
    });

    const update = {
      history: [...history, ...res.data],
      pagination: res.pagination,
    };
    dispatch({
      type: TYPES.GET_KWALLET_HISTORY_SUCCESS,
      data: {
        katWallet: type === enums.HISTORY_TYPE.KAT ? update : katWallet,
        kyteWallet: type === enums.HISTORY_TYPE.KYTE ? update : kyteWallet,
      },
    });
  } catch (error) {
    dispatch({
      type: TYPES.GET_KWALLET_HISTORY_FAILED,
      reason: error,
    });
  }
};
